import moment from "moment";
export default function formAPIlabs({
  verifieddate,
  uploadeddate,
  reportname,
  reportdescription,
  documenturl,
  imagepath,
  documents,
  reportid
})
{
  return Object.freeze({
    reportname,
  reportdescription,
  documenturl,
    verifieddate : verifieddate,
    uploadeddate,
    imagepath,
    documents,
    
  reportid
   
  });
}